module.exports = __webpack_public_path__ + "static/img/plan-task_06.6248c152.png";